module.exports = __webpack_public_path__ + "static/media/crash_5.53ccf3d5.mp3";